module.exports = __webpack_public_path__ + "static/media/settings_white.a250a7a8.svg";